import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { WalletContext } from "../../scripts/context/WalletContext";

export default function Wallet() {
  const { web3, connectWallet, errorMessage, loading, infoMessage } =
    useContext(WalletContext);
  const { account, contracts } = web3;

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <div className="d-flex flex-column-fluid w-100">
        <div className="container">
          {infoMessage && (
            <div className="row">
              <div className="col-md-5 mx-auto mt-0">
                <div class="d-flex align-items-center bg-light-primary rounded p-5 mb-9 status-div">
                  <span class="svg-icon svg-icon-primary mr-5">
                    <span class="svg-icon svg-icon-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24"></rect>
                          <circle
                            fill="#000000"
                            opacity="0.3"
                            cx="12"
                            cy="12"
                            r="10"
                          ></circle>
                          <rect
                            fill="#000000"
                            x="11"
                            y="10"
                            width="2"
                            height="7"
                            rx="1"
                          ></rect>
                          <rect
                            fill="#000000"
                            x="11"
                            y="7"
                            width="2"
                            height="2"
                            rx="1"
                          ></rect>
                        </g>
                      </svg>
                    </span>
                  </span>
                  <div class="d-flex flex-column flex-grow-1 mr-2">
                    <span
                      href="#"
                      class="text-primary py-1 font-size-lg font-size-status"
                    >
                      {infoMessage.split(" /b ")[1]}
                    </span>
                    <p class="text-white fw-bold d-block">
                      {infoMessage.split(" /b ")[0]}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
          {loading ? (
            <div className="row" style={{ height: "434.797px" }}>
              <div className="col-md-5 mx-auto mt-0">
                <div
                  className="card card-custom gutter-b card-stretch"
                  style={{ background: "unset" }}
                >
                  <span className="loading-row full-height full-width" />
                </div>
              </div>
            </div>
          ) : account.address &&
            contracts.presale.data.claimer &&
            !errorMessage ? (
            <Outlet />
          ) : (
            <div className="row full-height">
              <div
                className={`sc-17c8lce-2 bodOQc col-md-6 col-lg-5 mx-auto mt-0 ml-3 mr-3${
                  errorMessage ? " flex-column justify-content-start" : ""
                }`}
              >
                {errorMessage && (
                  <div className="col-12">
                    <div className="d-flex align-items-center bg-light-danger wallet-error rounded p-5 mb-9 status-div">
                      <span className="svg-icon svg-icon-danger mr-5">
                        <span className="svg-icon svg-icon-lg">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <rect x="0" y="0" width="24" height="24"></rect>
                              <path
                                d="M11.1669899,4.49941818 L2.82535718,19.5143571 C2.557144,19.9971408 2.7310878,20.6059441 3.21387153,20.8741573 C3.36242953,20.9566895 3.52957021,21 3.69951446,21 L21.2169432,21 C21.7692279,21 22.2169432,20.5522847 22.2169432,20 C22.2169432,19.8159952 22.1661743,19.6355579 22.070225,19.47855 L12.894429,4.4636111 C12.6064401,3.99235656 11.9909517,3.84379039 11.5196972,4.13177928 C11.3723594,4.22181902 11.2508468,4.34847583 11.1669899,4.49941818 Z"
                                fill="#000000"
                                opacity="0.3"
                              ></path>
                              <rect
                                fill="#000000"
                                x="11"
                                y="9"
                                width="2"
                                height="7"
                                rx="1"
                              ></rect>
                              <rect
                                fill="#000000"
                                x="11"
                                y="17"
                                width="2"
                                height="2"
                                rx="1"
                              ></rect>
                            </g>
                          </svg>
                        </span>
                      </span>
                      <div className="d-flex flex-column flex-grow-1 mr-2">
                        <span
                          href="#"
                          className="text-danger py-1 font-size-lg font-size-status"
                        >
                          {errorMessage.includes("/b")
                            ? errorMessage.split(" /b ")[1]
                            : "We got an error"}
                        </span>
                        <p
                          className="text-white fw-bold d-block text-break"
                          style={{ zIndex: "1" }}
                        >
                          {errorMessage.includes("/b") ? (
                            errorMessage
                              .split(" /b ")[0]
                              .includes("install metamask") ? (
                              <span className="text-white-80 mb-3">
                                Please install MetaMask, to install it{" "}
                                <a
                                  href="https://metamask.io/download/"
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{
                                    textDecoration: "underline",
                                    color: "white",
                                  }}
                                >
                                  click here
                                </a>
                              </span>
                            ) : (
                              errorMessage.split(" /b ")[0]
                            )
                          ) : (
                            errorMessage
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                )}
                <div className="sc-17c8lce-4 fTIUty justify-content-center center-absolute">
                  <button
                    style={{ maxWidth: "170px" }}
                    onClick={connectWallet}
                    id="connect-wallet"
                    className="sc-bdnxRM bhVlig sc-tdn257-0 sc-tdn257-4 sc-wwio5h-1 sc-wwio5h-3 gbdlPl cVOjRk idVMnL bmxxax"
                    type="button"
                  >
                    <p className="sc-wwio5h-5 bhIQsL">Connect to a Wallet</p>
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
